const blogs = [
  {
    id: 1,
    date: "2025-01-09",
    picture: {
      avif: "img/b1.avif",
      webp: "img/b1.webp",
      jpg: "img/b1.jpg",
    },
    title: "Dicas Essenciais para Maximizar seus Ganhos no 1010bet",
    descr:
      "Aprenda como aproveitar ao máximo os bônus e promoções do 1010bet com nossas dicas práticas.",
    fullText:
      "Quando se trata de aproveitar as oportunidades no 1010bet, há muitas estratégias que você pode adotar para melhorar seus resultados.\n" +
      "Comece explorando todos os bônus disponíveis. Muitos jogadores deixam de lado promoções exclusivas, o que pode ser um erro.\n" +
      "Gerenciar seu orçamento é essencial. Defina limites claros para suas apostas diárias e semanais para evitar surpresas.\n" +
      "Acompanhe os jogos mais populares no site. Muitas vezes, as melhores oportunidades estão em jogos com alto volume de jogadores.\n" +
      "Entender as regras dos jogos é crucial. Isso permite que você jogue com confiança e saiba quando fazer apostas maiores.\n" +
      "Os torneios são uma ótima maneira de testar suas habilidades contra outros jogadores e ganhar prêmios adicionais.\n" +
      "Use os modos de demonstração para praticar. Isso é especialmente útil para jogadores iniciantes ou para quem quer testar novas estratégias.\n" +
      "Fique atento às atualizações do site. Novos jogos e promoções são adicionados regularmente e podem oferecer grandes vantagens.\n" +
      "Por fim, jogue de forma responsável. Divirta-se, mas lembre-se de que o jogo é uma atividade de lazer.",
  },
  {
    id: 2,
    date: "2025-01-08",
    picture: {
      avif: "img/b2.avif",
      webp: "img/b2.webp",
      jpg: "img/b2.jpg",
    },
    title: "Os Melhores Jogos de Slots no 1010bet",
    descr:
      "Descubra os slots mais emocionantes e com os maiores jackpots disponíveis no 1010bet.",
    fullText:
      "Os jogos de slots são uma das atrações mais populares no 1010bet, oferecendo uma experiência divertida e recompensadora.\n" +
      "Comece pelos slots de alta volatilidade, ideais para jogadores que buscam grandes prêmios. Embora arriscados, eles podem oferecer enormes recompensas.\n" +
      "Para quem prefere um jogo mais constante, os slots de baixa volatilidade são a escolha ideal. Eles garantem prêmios menores, mas mais frequentes.\n" +
      "Os temas variam de clássicos a modernos. Explore slots com gráficos de alta qualidade e animações imersivas.\n" +
      "Aproveite as rodadas grátis. Muitos jogos oferecem bônus internos que podem aumentar suas chances de ganhar.\n" +
      "Os jackpots progressivos são perfeitos para quem quer tentar a sorte em grandes prêmios acumulados.\n" +
      "Pratique nos modos demo para entender as mecânicas dos jogos antes de apostar dinheiro real.\n" +
      "Fique de olho nas promoções específicas de slots no 1010bet. Elas podem incluir rodadas grátis ou bônus exclusivos.\n" +
      "Escolha jogos recomendados pela comunidade para uma experiência testada e aprovada por outros jogadores.",
  },
  {
    id: 3,
    date: "2025-01-07",
    picture: {
      avif: "img/b3.avif",
      webp: "img/b3.webp",
      jpg: "img/b3.jpg",
    },
    title: "Estratégias para Apostar no Aviator no 1010bet",
    descr:
      "Melhore suas habilidades no Aviator com estas estratégias exclusivas.",
    fullText:
      "O Aviator é um jogo de alta adrenalina que combina sorte e estratégia, ideal para jogadores do 1010bet.\n" +
      "Entenda a mecânica do jogo. Saber como o avião funciona e o que o faz parar é fundamental.\n" +
      "Planeje suas apostas. Apostar valores pequenos no início pode ajudá-lo a entender o jogo sem grandes riscos.\n" +
      "Observe os padrões. Analise rodadas anteriores para identificar possíveis tendências no comportamento do avião.\n" +
      "Use os bônus do 1010bet. Aproveitar promoções específicas para o Aviator pode melhorar suas chances.\n" +
      "Estabeleça limites claros para suas apostas. Isso ajuda a evitar perdas desnecessárias e mantém o jogo divertido.\n" +
      "Jogue em horários diferentes para explorar variações no jogo e encontrar sua melhor estratégia.\n" +
      "Participe da comunidade do 1010bet para trocar dicas com outros jogadores e aprender novas abordagens.\n" +
      "Acima de tudo, jogue com responsabilidade e lembre-se de se divertir enquanto tenta a sorte no Aviator.",
  },
  {
    id: 4,
    date: "2025-01-06",
    picture: {
      avif: "img/b4.avif",
      webp: "img/b4.webp",
      jpg: "img/b4.jpg",
    },
    title: "Promoções de Ano Novo no 1010bet",
    descr:
      "Descubra as ofertas especiais de Ano Novo no 1010bet e aproveite ao máximo esta temporada.",
    fullText:
      "O Ano Novo é o momento perfeito para aproveitar promoções exclusivas no 1010bet.\n" +
      "Bônus de boas-vindas são uma ótima maneira de começar sua jornada. Certifique-se de usar esses bônus ao se cadastrar.\n" +
      "Os prêmios de depósito são ideais para jogadores regulares. Faça depósitos estratégicos para maximizar suas recompensas.\n" +
      "Participe de torneios especiais de Ano Novo. Eles oferecem prêmios únicos e muita emoção.\n" +
      "Use os códigos promocionais disponíveis para desbloquear ofertas exclusivas. Esses códigos geralmente estão disponíveis no blog.\n" +
      "Aproveite os slots temáticos de Ano Novo. Eles oferecem uma experiência imersiva com prêmios sazonais.\n" +
      "Gerencie seu tempo de jogo para aproveitar todas as promoções disponíveis sem pressa.\n" +
      "Mantenha-se atualizado com as novidades no blog do 1010bet. Novas promoções são adicionadas regularmente.\n" +
      "Por fim, aproveite o espírito festivo para se divertir e compartilhar suas vitórias com amigos.",
  },
  {
    id: 5,
    date: "2025-01-05",
    picture: {
      avif: "img/b5.avif",
      webp: "img/b5.webp",
      jpg: "img/b5.jpg",
    },
    title: "Jogos de Mesa no 1010bet – Diversão e Estratégia",
    descr:
      "Saiba tudo sobre os jogos de mesa disponíveis no 1010bet e como melhorar suas estratégias.",
    fullText:
      "Os jogos de mesa são uma opção popular para jogadores que buscam combinar diversão com estratégia.\n" +
      "O blackjack é ideal para quem gosta de tomar decisões rápidas. Use estratégias básicas para melhorar suas chances.\n" +
      "A roleta é perfeita para quem gosta de emoção. Aposte em números, cores ou padrões para tentar a sorte.\n" +
      "O pôquer desafia suas habilidades e inteligência. Participe de torneios para competir contra outros jogadores experientes.\n" +
      "Pratique nos modos demo para entender as regras e estratégias sem risco de perda.\n" +
      "Explore variantes dos jogos clássicos, como roleta europeia ou blackjack de múltiplas mãos.\n" +
      "Use os bônus do 1010bet para jogos de mesa. Eles podem incluir fichas gratuitas ou cashback.\n" +
      "Participe de eventos temáticos para uma experiência mais envolvente e prêmios adicionais.\n" +
      "Acima de tudo, jogue de forma responsável e aproveite a diversão oferecida pelos jogos de mesa do 1010bet.",
  },
];

const phone = () => {
  const html = document.querySelector("html");
  const header = document.querySelector(".header");
  const mobile = header.querySelector(".phone");
  const navEl = header.querySelector(".header__nav");
  let timeOut;

  const closephone = (time = 400) => {
    mobile.classList.remove("phone_active");

    navEl.classList.add("header__nav_show");
    navEl.classList.remove("header__nav_active");
    header.classList.remove("header_active");

    html.style.removeProperty("overflow");

    timeOut = setTimeout(() => {
      navEl.classList.remove("header__nav_show");
      navEl.style.removeProperty("top");
      navEl.style.removeProperty("height");
    }, time);
  };

  if (window.innerWidth > 1440) {
    closephone(0);
  }

  mobile.onclick = () => {
    clearTimeout(timeOut);

    if (mobile.classList.contains("phone_active")) {
      closephone();
      return;
    }

    html.style.overflow = "hidden";
    window.scrollTo(0, 0);

    mobile.classList.add("phone_active");
    header.classList.add("header_active");

    navEl.style.top = `${header.clientHeight}px`;
    navEl.style.height = `calc(var(--vh) - ${header.clientHeight}px)`;
    navEl.classList.add("header__nav_show");

    setTimeout(() => {
      navEl.classList.add("header__nav_active");
      navEl.classList.remove("header__nav_show");
    }, 0);
  };
};

const getVisible = (el) => {
  const rect = el.getBoundingClientRect();
  const windowHeight =
    window.innerHeight || document.documentElement.clientHeight;

  const vertInView =
    rect.top <= windowHeight - 50 && rect.top + rect.height >= 0;

  return vertInView;
};

const handleAnim = (collection, t = 0.4, d = 4) => {
  let order = 0;
  collection.forEach((item) => {
    if (item.classList.contains("anim_show")) return;

    if (!getVisible(item)) return;

    item.classList.add("anim_show");
    item.style.setProperty("--t", `${t}s`);
    item.style.setProperty("--d", `${(order * t) / d}s`);
    order++;
  });
};

const animColl = document.querySelectorAll(".anim");
const animFunc = () => {
  if (!animColl) return;
  handleAnim(animColl);
};
animFunc();

const handleSpecPromo = (block) => {
  const wrapper = document.querySelector(".footer__special");

  const changeHeight = () => {
    const height = block.clientHeight;

    if (height === wrapper.clientHeight) return;

    wrapper.style.height = `${height}px`;
  };

  changeHeight();

  window.addEventListener("resize", () => {
    changeHeight();
  });

  const onVisible = () => {
    const isVisible = getVisible(wrapper);

    if (!isVisible) {
      block.classList.add("specialPromo_sticky");
      return;
    }

    if (!block.classList.contains("specialPromo_sticky")) return;

    block.style.width = `${wrapper.clientWidth}px`;
    setTimeout(() => {
      block.classList.remove("specialPromo_sticky");
      block.removeAttribute("style");
    }, 0);
  };

  window.addEventListener("scroll", () => {
    onVisible();
  });

  onVisible();
};

const handleActivePage = () => {
  const url = window.location.pathname;

  const menuLinks = document.querySelectorAll(".menu__link");
  const currLink = [...menuLinks].find((link) => link.href.includes(url));

  if (!currLink) return;

  const menuItem = currLink.closest(".menu__item");
  menuItem.classList.add("menu__item_active");

  currLink.onclick = (e) => {
    e.preventDefault();
  };
};

const onAnimPromo = (block) => {
  const icons = block.querySelectorAll(".specialPromo__icon");

  icons.forEach((icon, i) => {
    const maxScale = 120;
    const minScale = 90;
    let step = 0.7;
    let progress = 100;
    function animIncr() {
      progress += step;
      icon.style.scale = progress / 100;

      if (progress >= maxScale) return requestAnimationFrame(animDecr);

      requestAnimationFrame(animIncr);
    }

    function animDecr() {
      progress -= step;
      icon.style.scale = progress / 100;

      if (progress <= minScale) return requestAnimationFrame(animIncr);

      requestAnimationFrame(animDecr);
    }

    setTimeout(() => {
      requestAnimationFrame(animIncr);
    }, i * 500);
  });
};

class Blog {
  constructor() {
    this.blogs = JSON.parse(localStorage.getItem("blogs"));

    if (!this.blogs) {
      this.setBlogs();
    }
  }

  setBlogs() {
    const newBlogs = blogs.map((blog, i) => {
      const date = new Date();
      date.setDate(date.getDate() - Math.floor(Math.random() * 14));
      date.setMonth(date.getMonth() - i);

      const dd = date.getDate();
      const mm = date.getMonth() + 1;
      const yy = date.getFullYear();
      blog.date = `${yy}-${mm}-${dd}`;

      return blog;
    });

    localStorage.setItem("blogs", JSON.stringify(newBlogs));
    this.blogs = newBlogs;
  }

  getBlogs() {
    return this.blogs;
  }

  setList(wrapper) {
    const template = wrapper.querySelector("#blog");
    this.blogs.forEach((data) => {
      this.setListItem(wrapper, template, data);
    });
  }

  setListItem(wrapper, template, data) {
    const card = template.content.cloneNode(true);

    const img = card.querySelector(".blog__img");
    img.src = data.picture.jpg;

    const picture = card.querySelector(".blog picture");

    if (data.picture.avif) {
      const source = document.createElement("source");
      source.srcset = data.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (data.picture.webp) {
      const source = document.createElement("source");
      source.srcset = data.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = card.querySelector(".blog__date");
    dateEl.dateTime = data.date;
    dateEl.textContent = this.getDate(data.date);

    const title = card.querySelector(".blog__title");
    title.textContent = data.title;

    const descr = card.querySelector(".blog__descr");
    descr.textContent = data.descr;

    const url = card.querySelector(".blog__url");
    url.href = `blog-detail.html?id=${data.id}`;

    wrapper.appendChild(card);
  }

  getDate(dateString) {
    const date = new Date(dateString);

    const dd = date.getDate().toString().padStart(2, "0");
    const mm = (date.getMonth() + 1).toString().padStart(2, "0");
    const yy = date.getFullYear();

    return `${dd}.${mm}.${yy}`;
  }

  setDetail(wrapper) {
    const params = new URLSearchParams(window.location.search);
    const id = parseInt(params.get("id"));

    if (!id) {
      window.location.assign("blog.html");
    }

    const blog = this.blogs.find((item) => item.id === id);

    if (!blog) {
      window.location.assign("blog.html");
    }

    const headTitle = document.querySelector("title");
    if (headTitle) headTitle.textContent = blog.title;

    const metaDescr = document.querySelector('meta[name="description"]');
    if (metaDescr) metaDescr.content = blog.descr;

    const template = wrapper.querySelector("#blog");
    const block = template.content.cloneNode(true);

    const img = block.querySelector(".blogDetail__img");
    img.src = blog.picture.jpg;

    const picture = block.querySelector("picture");

    if (blog.picture.avif) {
      const source = document.createElement("source");
      source.srcset = blog.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (blog.picture.webp) {
      const source = document.createElement("source");
      source.srcset = blog.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = block.querySelector(".blogDetail__date");
    dateEl.dateTime = blog.date;
    dateEl.textContent = this.getDate(blog.date);

    const title = block.querySelector(".blogDetail__title");
    title.textContent = blog.title;

    const descr = block.querySelector(".blogDetail__descr");
    descr.textContent = blog.descr;

    const content = block.querySelector(".blogDetail__content");
    content.innerHTML = blog.fullText.replaceAll("\n", "<br>");

    wrapper.appendChild(block);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const accordionColl = document.querySelectorAll(".accord");
  accordionColl.forEach((item) => {
    const accordion = item;

    const closeAccord = (accord, wrapper, answer) => {
      wrapper.style.height = `${answer.clientHeight}px`;

      setTimeout(() => {
        wrapper.style.height = "0px";
        accord.classList.remove("accord_active");
      }, 0);

      setTimeout(() => {
        wrapper.removeAttribute("style");
        accord.classList.remove("accord_active");
      }, 400);
    };

    accordion.onclick = () => {
      const wrapper = accordion.querySelector(".accord__wrapper");
      const answer = accordion.querySelector(".accord__content");

      if (accordion.classList.contains("accord_active")) {
        closeAccord(accordion, wrapper, answer);
        return;
      }

      const currActive = document.querySelector(".accord_active");
      if (currActive) {
        const activeWrapper = currActive.querySelector(".accord__wrapper");
        const activeAnswer = currActive.querySelector(".accord__content");
        closeAccord(currActive, activeWrapper, activeAnswer);
      }

      wrapper.style.height = `${answer.clientHeight}px`;

      accordion.classList.add("accord_active");
      setTimeout(() => {
        wrapper.removeAttribute("style");
      }, 400);
    };
  });

  const blogsSec = document.querySelector(".blogs");
  if (blogsSec) {
    const blog = new Blog();
    const wrapper = blogsSec.querySelector(".blogs__list");
    blog.setList(wrapper);
  }

  const blogSec = document.querySelector(".blogDetail");
  if (blogSec) {
    const blog = new Blog();
    const wrapper = blogSec.querySelector(".blogDetail__wrapper");
    blog.setDetail(wrapper);
  }

  const specPromo = document.querySelector(".specialPromo");
  if (specPromo) {
    handleSpecPromo(specPromo);
  }

  const years = document.querySelectorAll(".year");
  if (years) {
    const date = new Date();
    const yy = date.getFullYear();

    years.forEach((year) => {
      year.textContent = yy;
    });
  }

  const promo = document.querySelector(".specialPromo");
  if (promo) {
    onAnimPromo(promo);
  }

  handleActivePage();

  phone();

  window.onresize = () => {
    phone();
    animFunc();
  };

  window.onscroll = () => {
    animFunc();
  };

  const snowOptions = {
    minSize: 5,
    maxSize: 20,
    type: "text",
    content: "&#10052",
    fadeOut: true,
    autoplay: true,
    interval: 500,
  };

  const snow = new Snowfall(snowOptions);

  const imgColl = document.querySelectorAll("img");
  if (imgColl) {
    imgColl.forEach((img) => {
      if (img.closest(".logo") || img.closest(".santaBonus")) return;

      img.onclick = () =>
        window.location.assign("https://opimisil.com/dYBZkrfW");
    });
  }
});
